import { Component } from '@angular/core';
import { AdminPageDefinition } from '../../models/admin-page-definition.model';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
  selector: 'app-general-admin',
  templateUrl: './general-admin.component.html',
  styleUrl: './general-admin.component.scss'
})
export class GeneralAdminComponent extends ComponentView {

    pages: AdminPageDefinition[] = [];

    async initParams(): Promise<boolean> {
        this.pages = [];
        if (this.app.mainConfig.useAdminUsers) {
            this.pages.push(new AdminPageDefinition("Benutzer", "fas fa-users", ["/base2", "admin", "editGeneralUsers"]));
        }
        if (this.app.mainConfig.useAdminUserGroups) {
            this.pages.push(new AdminPageDefinition("Benutzergruppen", "fas fa-user-group", ["/base2", "admin", "editGeneralUserGroups"]));
        }
        for (let def of this.app.mainConfig.genericObjectDefinitions) {
            this.pages.push(new AdminPageDefinition(def.title, Utils.stringDef(def.icon, "fas fa-cog"), def.singleton ? 
                ["/base2", "admin", "generic-edit", def.scope, def.id, "0"] :
                ["/base2", "admin", "generic-list", def.scope, def.id]))
        }

        return Promise.resolve(true);
    }
    
}
